import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../services/api";
import Logo from "../../assets/logo.png";

const MotDePasseOublie = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      await api.post("/auth/mot-de-passe-oublie", { email });
      setMessage("Si cet email existe, un lien de réinitialisation a été envoyé.");
    } catch (err) {
      setError(err.response?.data?.error || "Une erreur est survenue");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", backgroundColor: "white",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      padding: "2rem"
    }}>
      {/* Logo */}
      <img src={Logo} alt="Banque Bleue" style={{ width: "80px", marginBottom: "1.5rem" }} />

      {/* Titre */}
      <h2 style={{ fontSize: "1.5rem", fontWeight: 700, color: "#1f2937", marginBottom: "0.5rem" }}>
        Mot de passe oublié
      </h2>
      <p style={{ fontSize: "0.9rem", color: "#6b7280", marginBottom: "1.5rem", textAlign: "center", maxWidth: "360px" }}>
        Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
      </p>

      {/* Message succès */}
      {message && (
        <div style={{
          width: "100%", maxWidth: "380px", marginBottom: "1rem",
          padding: "0.75rem 1rem", backgroundColor: "#f0fdf4",
          border: "1px solid #86efac", borderRadius: "0.5rem",
          color: "#16a34a", fontSize: "0.875rem"
        }}>
          {message}
        </div>
      )}

      {/* Message erreur */}
      {error && (
        <div style={{
          width: "100%", maxWidth: "380px", marginBottom: "1rem",
          padding: "0.75rem 1rem", backgroundColor: "#fef2f2",
          border: "1px solid #fecaca", borderRadius: "0.5rem",
          color: "#dc2626", fontSize: "0.875rem"
        }}>
          {error}
        </div>
      )}

      {/* Formulaire */}
      {!message && (
        <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "380px" }}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Votre email"
            required
            style={{
              width: "100%", padding: "0.75rem 1rem",
              border: "1px solid #d1d5db", borderRadius: "0.5rem",
              fontSize: "1rem", color: "#374151", outline: "none",
              marginBottom: "1rem", boxSizing: "border-box", background: "white"
            }}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%", padding: "0.85rem",
              background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
              color: "white", fontWeight: 700, fontSize: "1rem",
              borderRadius: "9999px", border: "none",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
              boxShadow: "0 4px 14px rgba(37,99,235,0.4)"
            }}
          >
            {loading ? "Envoi en cours..." : "Envoyer le lien"}
          </button>
        </form>
      )}

      {/* Retour login */}
      <Link
        to="/login"
        style={{
          marginTop: "1.5rem", fontSize: "0.875rem",
          color: "#6b7280", textDecoration: "none",
          display: "flex", alignItems: "center", gap: "0.25rem"
        }}
      >
        ← Retour à la connexion
      </Link>
    </div>
  );
};

export default MotDePasseOublie;